import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import { useSelectorTrigger } from "app/components/filters-bar/useSelectorTrigger";
import CountryService from "app/services/CountryService";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { useSocialTrafficContext } from "app/pages/website-analysis/social-overview/socialTraffic/context";

const DEFAULT_DATE_FORMAT = "YYYY-MM";

export const SubTitle = () => {
    const { params } = useSocialTrafficContext();
    const { country, duration } = params;
    const durationObject = DurationService.getDurationData(duration);
    const fromDate = durationObject.raw.from;
    const toDate = durationObject.raw.to;
    const { selectorHandlers } = useSelectorTrigger("social-traffic");
    const subtitleFilters = [
        {
            filter: "date",
            value: {
                from: fromDate.valueOf(),
                to: toDate.valueOf(),
                useRangeDisplay:
                    duration !== BasicDurations.LAST_TWENTY_EIGHT_DAYS &&
                    fromDate.format(DEFAULT_DATE_FORMAT) !== toDate.format(DEFAULT_DATE_FORMAT),
            },
            onClick: selectorHandlers.onDateClick,
            onMouseEnter: selectorHandlers.onDateHover,
        },
        {
            filter: "country",
            countryCode: country,
            value: CountryService.getCountryById(country)?.text,
            onClick: selectorHandlers.onCountryClick,
            onMouseEnter: selectorHandlers.onCountryHover,
        },
        {
            filter: "webSource",
            value: "Total",
            onMouseEnter: selectorHandlers.onWebSourceHover,
        },
    ];
    return (
        <div>
            <StyledBoxSubtitle>
                <BoxSubtitle filters={subtitleFilters} />
            </StyledBoxSubtitle>
        </div>
    );
};
